<template>
  <div v-if="categoryData" style="margin-top: 10px; display: flex;">
    <select @change="onChange" v-model="categoryData.foodCategory" style="width: 91.5%; height: 24px;">
      <option value=""></option>
      <option v-for="catGroup in foodCategories" :key="catGroup.idItem" :value="catGroup.idItem"
        :class="catGroup.isMainGroup ? 'bold' : 'normal'">
        <span v-if="catGroup.isMainGroup">{{ catGroup.description }}</span>
        <span v-if="!catGroup.isMainGroup">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ catGroup.description }}</span>
      </option>
    </select>
    <div v-if="index > 2" style="cursor: pointer;" @click="removeItem()" :title="S0021"> <img width="24" height="24"
        src="../assets/recyclebin.png" /></div>
  </div>


</template>

<script>
import { getSTRING } from "@/js/utils";
export default {
  name: "CategoryList",
  props: ["lang", "itemData", "index", "foodCategories"],
  emits: { changedValue: null, removeitem: null },
  data() {
    return {
      language: 0,
      S0021: "",
      categoryData: {
        foodCategory: this.itemData.foodCategory
      }
    };
  },
  async mounted() {
    this.S0021 = getSTRING(this.lang, "S0021", "Rimuovi categoria")
    this.categoryData.foodCategory = this.itemData.foodCategory;
  },
  watch: {
    itemData: {
      handler(val) {
        this.categoryData.foodCategory = val.foodCategory;
      },
      deep: true
    }
  },
  methods: {
    onChange() {
      this.$emit("changedValue", this.categoryData, parseInt(this.index));
    },
    removeItem() {
      this.$emit("removeitem", this.index);
    }

  },
};
</script>

<style>
.bold {
  font-weight: bold;
  font-style: italic;
}

.normal {
  font-weight: normal;  
}
</style>